import Link from 'next/link';
import { useTranslation } from 'next-i18next';
import Heading from '@components/Heading/Heading';
import styles from '@components/InspirationListingHeader/InspirationListingHeader.styles';
import { ITagArticles, TInspirationsTypesSlug } from '@features/cms/typescript';
import Button from '@components/Button/Button';
type PropsType = {
  activeLink: TInspirationsTypesSlug;
  count: number;
  tags: ITagArticles[];
  activeTags: ITagArticles[];
  setActiveTags: (activeTags: ITagArticles[]) => void;
  setPageCount: (page: number) => void;
};
const InspirationListingHeader = ({
  activeLink,
  count,
  tags,
  activeTags,
  setActiveTags,
  setPageCount
}: PropsType) => {
  const {
    t
  } = useTranslation('common');

  // TODO make no static navigation in future
  const isIdeas = activeLink === 'ideas';
  const isInterior = activeLink === 'interior-designs';
  const handleTagButton = (tag: ITagArticles) => {
    setPageCount(1);
    if (activeTags.find(activeTag => activeTag.name === tag.name)) {
      return setActiveTags(activeTags.filter(activeTag => activeTag.name !== tag.name));
    }
    return setActiveTags([...activeTags, tag]);
  };
  const renderTagButton = (tag: ITagArticles, active: boolean): JSX.Element => <Button key={tag.name} variant="outlined" variantColor="brand" addSx={styles.button} onClick={() => handleTagButton(tag)} active={active}>
      {tag.name}
    </Button>;
  return <header sx={styles.headerSection}>
      <nav sx={styles.inspirationNav}>
        <Link href="/inspirations/ideas" sx={styles.inspirationLink(isIdeas)}>
          <Heading h={isIdeas ? 1 : 6} headingType={isIdeas ? undefined : 6} display={isIdeas ? 5 : undefined} uppercase={!isIdeas} capitalize={isIdeas} mobile>
            {t('ideas.plural')}
          </Heading>
          {isIdeas && <p className="subtitle">({count})</p>}
        </Link>
        <Link href="/inspirations/interior-designs" sx={styles.inspirationLink(isInterior)}>
          <Heading h={isInterior ? 1 : 6} headingType={isInterior ? undefined : 6} display={isInterior ? 5 : undefined} uppercase={!isInterior} capitalize={isInterior} mobile>
            {t('interiorDesign.plural')}
          </Heading>
          {isInterior && <p className="subtitle">({count})</p>}
        </Link>
      </nav>
      <div sx={styles.tagsContainer}>
        {tags.length > 0 && tags.map(tag => renderTagButton(tag, !!activeTags.find(activeTag => activeTag.name === tag.name)))}
      </div>
    </header>;
};
export default InspirationListingHeader;